<template>
  <v-menu rounded offset-y>
    <template #activator="{ attrs, on }">
      <v-btn
        outlined
        v-bind="attrs"
        small
        class="pa-0"
        :color="color"
        height="32px"
        width="56px"
        :disabled="disabled"
        v-on="on"
      >
        <v-icon class="ml-2">
          {{ mdiPrinter }}
        </v-icon>
        <v-icon>
          {{ mdiMenuDown }}
        </v-icon>
      </v-btn>
    </template>

    <v-list class="pa-0">
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        link
        dense
        ripple
      >
        <div class="body-2 d-flex justify-center" @click="setItem(item)">
          <component :is="item.icone" class="mr-2"></component>
          {{ item.text }}
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { mdiMenuDown, mdiPrinter } from '@mdi/js';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import IconTextoNorma from '@/views/components/icons/IconTextoNorma.vue';

interface IProps {
  items?: IItem[];
  disabled?: boolean;
  color?: string;
  returnObject?: boolean;
}

interface IItem {
  text: string;
  value: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icone: any;
}

interface IEmits {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'change', e: any): void;
}

const itemSelected = ref<IItem | null>(null);

const props = withDefaults(defineProps<IProps>(), {
  color: 'primary',
  items: () => [
    {
      text: 'Simplificado',
      value: 'S',
      icone: IconPaginaSimplificada,
    },
    {
      text: 'Detalhado',
      value: 'D',
      icone: IconPaginaDetalhada,
    },
    {
      text: 'Texto da norma',
      value: 'T',
      icone: IconTextoNorma,
    },
  ],
});

const emit = defineEmits<IEmits>();

const setItem = (item: IItem) => {
  itemSelected.value = item;

  if (props.returnObject) {
    return emit('change', itemSelected.value);
  }
  return emit('change', itemSelected.value.value);
};
</script>
